var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info',{staticClass:"article"},[_c('h1',[_vm._v(_vm._s(_vm.$t("EMPIRE_STRIKES_BACK")))]),_c('div',{domProps:{"innerHTML":_vm._s(
      _vm.$t('EMPIRE_STRIKES_BACK_DESC_1', {
        imageLink1: 'https://oldstatic.appdb.to/images/DSC01963.JPG',
        imageLink2: 'https://oldstatic.appdb.to/images/DSC01964.JPG',
        imageLink3: 'https://oldstatic.appdb.to/images/DSC01966.JPG',
        imageLink4: 'https://oldstatic.appdb.to/images/DSC01968.JPG',
        imageLink5: 'https://oldstatic.appdb.to/images/DSC01971.JPG',
      })
    )}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('EMPIRE_STRIKES_BACK_DESC_2'))}}),_c('div',{domProps:{"innerHTML":_vm._s(
      _vm.$t('EMPIRE_STRIKES_BACK_DESC_3', {
        githubLink: 'https://github.com/ZonD80?tab=repositories',
      })
    )}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('EMPIRE_STRIKES_BACK_DESC_4'))}}),_c('template',{slot:"sidebar"},[_c('h2',[_vm._v(_vm._s(_vm.$t("EMPIRE_STRIKES_BACK").toUpperCase()))]),_c('p',[_vm._v(_vm._s(_vm.$t("EMPIRE_STRIKES_BACK_READ_FULL_STORY")))]),_c('img',{attrs:{"src":"https://oldstatic.appdb.to/images/empire-right.jpg","width":"100%"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }